import { render, staticRenderFns } from "./HotelsAdvancedDetailPrices.vue?vue&type=template&id=7b91afc2&"
import script from "./HotelsAdvancedDetailPrices.vue?vue&type=script&lang=js&"
export * from "./HotelsAdvancedDetailPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports